// src/App.jsx
import './App.css';
import Home from './components/home/Home';
import Login from './components/login/Login';
import Audio from './components/audio/Audio';
import React from 'react';

import Adminhome from './components/home/Adminhome';
import Register from './components/login/Rregister';  // Add Register import
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from "./ProtectedRoute"; 

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} /> 

        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/audio/:id"
          element={
            <ProtectedRoute>
              <Audio />
            </ProtectedRoute>
          }
        />

        <Route
          path="/adminhome"
          element={
            <ProtectedRoute>
              <Adminhome />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

